import { render, staticRenderFns } from "./PersonNewsFeed.vue?vue&type=template&id=6f3793aa&scoped=true&"
import script from "./PersonNewsFeed.vue?vue&type=script&lang=js&"
export * from "./PersonNewsFeed.vue?vue&type=script&lang=js&"
import style0 from "./PersonNewsFeed.vue?vue&type=style&index=0&id=6f3793aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3793aa",
  null
  
)

export default component.exports